import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Home from './Components/Home/Home';
import SignIn from './Components/SignIn/SignIn';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './Components/Includes/Loader';
import OnlineStatus from './Components/Includes/OnlineStatus';
import NotFound from './Components/Includes/NotFound';
import AddDoctor from './Components/Doctors/AddDoctor';
import DoctorsList from './Components/Doctors/DoctorsList';
import EditDoctor from './Components/Doctors/EditDoctor';
import AddStaff from './Components/Staff/AddStaff';
import ViewStaff from './Components/Staff/ViewStaff';
import EditStaff from './Components/Staff/EditStaff';
import AddOpenHours from './Components/OpenHoursMnge/AddOpenHours';
import ViewOpenHours from './Components/OpenHoursMnge/ViewOpenHours';
import EditOpenHours from './Components/OpenHoursMnge/EditOpenHours';
import AppointmentList from './Components/Appointment/AppointmentList';
import PatientRecept from './Components/PatientRecept/PatientRecept';
import TokenCalling from './Components/TokenCalling/TokenCalling';
import PatientReceiptList from './Components/PatientRecept/PatientReceptList';

function App() {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const state = useSelector((state) => state.stateVals);
  const { id } = state;

  const handleSignIn = () => {
    setAuthenticated(true);
  };

  const handleSignOut = () => {
    setAuthenticated(false);
  };

  useEffect(() => {
    // Simulate loading delay
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (id) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }
  }, [id]);

  // Use localStorage to track if glitter has been shown
  useEffect(() => {
    if (authenticated) {
      // Check if glitter effect has been shown before
      const glitterShown = localStorage.getItem('glitterShown');
      if (!glitterShown) {
        // Create glitter particles only when authenticated and first login
        const container = document.createElement('div');
        container.className = 'glitter-container';

        for (let i = 0; i < 50; i++) {
          const glitter = document.createElement('div');
          glitter.className = 'glitter';
          glitter.style.left = `${Math.random() * 100}vw`;
          glitter.style.animationDuration = `${2 + Math.random() * 2}s`;
          glitter.style.animationDelay = `${Math.random() * 5}s`;
          container.appendChild(glitter);
        }

        document.body.appendChild(container);
        setTimeout(() => {
          container.remove();
        }, 5000); // Effect duration

        // Mark glitter as shown in localStorage
        localStorage.setItem('glitterShown', 'true');
      }
    }
  }, [authenticated]);

  return (
    <div className="App">
      <BrowserRouter>
      <OnlineStatus />
        {loading ? (
          <Loader />
        ) : (
          <Routes>
            <Route
              path="/"
              element={
                authenticated ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <SignIn onSignIn={handleSignIn} authenticated={authenticated} />
                )
              }
            />
            <>
            {/* <Route path="/dashboard" element={<Home/>} /> */}

              <Route path="/dashboard" element={authenticated ? <Home onSignOut={handleSignOut} /> : <Navigate to="/" />} />
              <Route path="/add-doctor" element={authenticated ? <AddDoctor /> : <Navigate to="/" />} />
              <Route path="/doctors-list" element={authenticated ? <DoctorsList /> : <Navigate to="/" />} />
              <Route path="/edit-doctor/:id" element={authenticated ? <EditDoctor /> : <Navigate to="/" />} />
              <Route path="/add-staff" element={authenticated ? <AddStaff /> : <Navigate to="/" />} />
              <Route path="/view-staff" element={authenticated ? <ViewStaff /> : <Navigate to="/" />} />
              <Route path="/edit-staff/:id" element={authenticated ? <EditStaff /> : <Navigate to="/" />} />

                            <Route path="/add-hour" element={authenticated ? <AddOpenHours /> : <Navigate to="/" />} />
              <Route path="/view-hour" element={authenticated ? <ViewOpenHours /> : <Navigate to="/" />} />
              <Route path="/edit-hour/:id" element={authenticated ? <EditOpenHours /> : <Navigate to="/" />} />
              <Route path="/view-appointment" element={authenticated ? <AppointmentList /> : <Navigate to="/" />} />
              <Route path="/patient-receipt" element={authenticated ? <PatientRecept /> : <Navigate to="/" />} />
              <Route path="/patient-receipt-list" element={authenticated ? <PatientReceiptList /> : <Navigate to="/" />} />
              <Route path="/token-calling" element={authenticated ? <TokenCalling /> : <Navigate to="/" />} />


              <Route path="*" element={<NotFound />} /> 
            </>
          </Routes>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
